import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCheck, lucideCopy } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmInputImports } from '@spartan-ng/helm/input';

/** The partner's register link (?ref=CODE), to copy and share. */
@Component({
  selector: 'app-partner-link-card',
  standalone: true,
  imports: [NgIcon, HlmButtonImports, HlmCardImports, HlmInputImports],
  providers: [provideIcons({ lucideCheck, lucideCopy })],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './partner-link-card.component.html',
})
export class PartnerLinkCardComponent {
  readonly link = input.required<string>();
  readonly copied = signal(false);

  copy(): void {
    navigator.clipboard?.writeText(this.link()).then(() => {
      this.copied.set(true);
      setTimeout(() => this.copied.set(false), 2000);
    });
  }
}
